define(function (require) {
    var $ = require("jquery");
    require("bootstrap.notify");
    var ajax = require("ajax-promise");
    var selenium = require("selenium-helper");
	var i18n = require("i18n");


    //post json error server side
    function _asyncLogToServer(oError)
    {
        var oErrorPost = { message: oError.message, url: window.location.toString() };
        if (oError.stack)
        {
            oErrorPost.stack = oError.stack;
        }

        var oAjaxOptions = { contentType: 'application/json' };
        //encode content as json, otherwise it will be posted as form data and can trigger a "dangerous request error" server side
        ajax.post('/Error/LogJS', JSON.stringify(oErrorPost), oAjaxOptions).catch(function (err)
        {

            if (console && console.log)
            {
                console.log('Failed to send js error to server');
                console.log(err);
            }
        });
    }

    //always return { message : string,  stack?:any } so that we dont care if it's a string or an error
    function _normalizeError(exceptionOrString)
    {
        var oError = {};
        var isString = typeof exceptionOrString === "string";
       
        if (isString) {
            oError.message = exceptionOrString;
        }
        else if (exceptionOrString)
        {
            oError.message = exceptionOrString.message;
            oError.stack = exceptionOrString.stack;
        }
        return oError;
    }


	/***
	 *   affiche une erreur à l'utilisateur et log coté serveur
	 *   oOptions : {	bIsWarning,   //affiche le message en warning au lieu de error
     *					bSkipServerLog,  // ne log pas coté serveur
     *				    bSkipUserDisplay // n'affiche pas l'erreur à l'utilisateur (sauf si on a un cookie displayAllErrors=1 )
	 */
    function _handleError(exceptionOrString, oOptions)
    {
        oOptions = oOptions || {};

        var bIsWarning = !!oOptions.bIsWarning;
		//si l'option bSkipServerLog est renseignée, on utilise sa valeur, sinon on skip si le niveau est warning
        var bSkipServerLog = ('bSkipServerLog' in oOptions) ? oOptions.bSkipServerLog : bIsWarning;
        var bSkipUserDisplay = oOptions.bSkipUserDisplay;

        if (bSkipUserDisplay)
        {
			//force l'affichage des erreurs
            if ((document.cookie || '').indexOf('displayAllErrors=1') !== -1)
            {
                bSkipUserDisplay = false;
            }
        }


        try {
            var oError = _normalizeError(exceptionOrString);

            //display error in UI
            if (!bSkipUserDisplay)
            {
				var finalMessage = oError.message;

				if (i18n.genericErrorMessage != null && !bIsWarning)
					finalMessage = i18n.genericErrorMessage + " " + finalMessage;

                $.notify({
                    icon: 'fa fa-exclamation-triangle',
					message: finalMessage
                },
				{
					type: (bIsWarning ? 'warning' : 'danger')
				});

            }

            //Display avec stack trace dans la console si présente
            if (console && console.log) {
                console.log(oError.message);
                if (oError.stack) {
                    console.log(oError.stack);
                }
            }

            if (!bSkipServerLog)
            {
                //log error for selenium test to check a js error occured
                selenium.log('error', oError.message, oError);

                _asyncLogToServer(oError);
            }
        }
        catch (err2) {
            if (console && console.log) {
                console.log('error in error-handler', err2);
            }
        }

    }

    var exports = {};
    exports.handleError = _handleError;
	
    //Affiche une erreur à l'utilisateur final
    exports.displayError = function (exceptionOrString) {
        _handleError(exceptionOrString);

    };

    exports.displayWarning = function (exceptionOrString) {
        _handleError(exceptionOrString, { bIsWarning: true, bSkipServerLog: true });
    };

    return exports;
});
